import React from 'react';
import '../../App.css';
import Ownpic from '../Ownpic';
import Cards from '../Cards';
import Footer from '../Footer';
import Contactform from '../Contactform';

function Home() {
  return (
    <>
        <Ownpic />
        <Cards />
        <Contactform />
        <Footer />
    </>
  );
}

export default Home;
